export default function () {
  if (this.$route.name === 'EditModality') {
    this.loadModality()
  }
}
